import { EntityMetadataMap } from '@ngrx/data';

export const KE_SCHEDULES_WORKFLOWS_LIST_ENTITY_NAME = 'keSchedulesWorkflows';

const entityMetadata: EntityMetadataMap = {
  [KE_SCHEDULES_WORKFLOWS_LIST_ENTITY_NAME]: {
    entityDispatcherOptions: { optimisticAdd: false, optimisticUpdate: false },
  },
};

export const keSchedulesWorkflowsEntityConfig = {
  entityMetadata,
};
